import _ from "lodash";
import {ApolloClient, OperationVariables, QueryOptions} from '@apollo/client'
import type { DocumentNode } from "graphql";
import type { TypedDocumentNode } from "@graphql-typed-document-node/core";
import merge from "deepmerge";
import { Page } from "components/table/LargeTable";
import { FlashAutoOutlined } from "@mui/icons-material";

export type RequestInfo = {
    description: string;
    variables: OperationVariables;
    query: DocumentNode;
    dataPath: string;
    countPath: string;
}

export type ToTableRow = (row : any) => {
  id: any;
  priority?: any;
  onClick?: (e : any) => any;
  cells: any;
}

export function createDataLoader(client : ApolloClient<object>, requestInfo : RequestInfo, toTableRow : ToTableRow, complexSearch : Boolean = false ) {
  return (page : Page, 
          errorCallback : (message: string, reason: string) => void, 
          dataCallback : (result: any) => void) => {
    var cancelled = false;
    client.query(createRequest(requestInfo, page, complexSearch))
      .then(
        result => {
          if (cancelled) return
          console.debug("dataLoader: result=%o", result)
          const count = _.get(result, requestInfo.countPath)
          const data = _.get(result, requestInfo.dataPath)
          const rows = data ? data.map((row : any) => toTableRow(row)) : []
          if (cancelled) return
          dataCallback({ rows, count, page })
        },
        error => {
          if (cancelled) return
          errorCallback(`Failed to get table data for ${requestInfo.description}: ${error.message}`, error)
        }
      )
      .catch(reason => {
        if (cancelled) return
        errorCallback("A Frontend Issue occured while processing the table data", reason)
      })
      .finally(() => {
        // done succesfully or with an error
      })
    return {
      cancel: () => { 
        console.debug("dataLoader: cancelling request")
        cancelled = true 
      }
    }
  }
}

function createRequest(requestInfo : RequestInfo, page : Page, complexSearch : Boolean) : QueryOptions<OperationVariables, any>{
  const effectiveFilter = page.filterType === "local" || (page.filter?.search_text.length === 0 && 
                                                          page.filter?.num_filters?.length === 0 && 
                                                          page.filter?.date_filters?.length === 0 && 
                                                          page.filter?.text_filters?.length === 0 && 
                                                          page.filter?.sort_setting == null) ? null : page.filter
  return {
    query: requestInfo.query,
    variables: merge.all([
      requestInfo.variables,
      {
        filter: complexSearch ? effectiveFilter : effectiveFilter?.search_text,
        start: page.pageNum * page.pageSize,
        count: page.pageSize
      }
    ])
  }
}